<template>
    <!--软件启明瞳-->
    <div style="width: 100%">
      <div class="productInfoArea">
        <div class="totalProduct">
          <div class="video">
            <video-player class="vjs-custom-skin"
                          :options="playerOptions"
                          ref="videoPlayer">
            </video-player>
          </div>
          <div class="textInfo">
            <!--产品名字-->
            <span class="productTitle">{{productInfo.productTitle}}</span>
            <!--产品简介-->
            <p class="shortInfo">
              <span style="display: inline-block;width: 50%;text-align: right">下载量</span>：
              <span style="display: inline-block;width: 50%;text-align: left">{{productInfo.downloadCount}}</span>
            </p>
            <p class="shortInfo">
              <span style="display: inline-block;width: 50%;text-align: right">应用版本</span>：
              <span style="display: inline-block;width: 50%;text-align: left">{{productInfo.appVersion}}</span>
            </p>
            <p class="shortInfo">
              <span style="display: inline-block;width: 50%;text-align: right">上架时间</span>：
              <span style="display: inline-block;width: 50%;text-align: left">{{transDate(productInfo.createDate)}}</span>
            </p>
            <p class="contentInfo">{{productInfo.productDescribe}}</p>
            <div class="Download">
              <Button type="success" size="large" style="width: 100px" @click.native="androidDown(productInfo.downloadUrl, productInfo.id, productInfo.downloadCount)">安卓下载</Button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <p style="font-size: 1.1rem;margin: 1% 1% 1% 4%;display: inline-block;color:rgba(0, 171, 169, 1);">同类产品</p>
        <Button type="text" style="display: inline-block;float: right;margin:1% 3% 2% 0;color:rgba(0, 171, 169, 1);"
                @click.native="toProductPage">更多
          <Icon type="ios-more"/>
        </Button>
        <hr style="border-bottom:1px solid rgba(23, 219, 244, 1) ;border-top:none;"/>
      </div>
      <div class="software">
        <div class="productInfoList"  v-for="(value,index) in software" :key="index">
          <!--产品名字-->
          <img class="listImg" :src="value.appLogo" @click="toProductionShow(value.packageName)"><br>
          <span class="listInfo">{{value.productTitle}}</span>
        </div>
      </div>
      <div class="footer">
        <ul style="display: flex;align-items: center;flex-direction: column;list-style: none;justify-content: center; height: 100%">
          <li class="info">Copyright © 2017-2020 All rights reserved 版权所有 © 无障碍科技有限公司</li>
          <li class="info">备案号：鄂ICP备18005954号</li>
        </ul>
      </div>
    </div>
</template>

<script>
    import {formatDate} from "../../utils/format";

    export default {
        name: "productDetails",
        data(){
            return{
                playerOptions: {},
                productInfo: {},
                software: [],
                imgList: [],
            }
        },
        methods:{
            transDate(time){
                return formatDate(new Date(time), 'yyyy-MM-dd')
            },
            toProductPage(){
                this.$router.push('/productionShow');
            },//跳转到产品展示页面
            toProductionShow(packageName){
                let routeUrl;
                if (packageName){
                     routeUrl = this.$router.resolve({
                        path:'/productDetails?packageName=' + packageName
                    });
                } else {
                     routeUrl = this.$router.resolve({
                        path:'/productionShow'
                    });
                }
                window.open(routeUrl.href, '_blank');
            },//点击产品跳转到产品展示页面，并定位到该产品
            getInfo(packageName){
                this.$http.post('/zm/WMWebsite/queryProductInfos', {'packageName': packageName}).then(
                    res => {
                        let tempData = res.data.content;
                        for (let i = 1; i <=3; i++){
                            if (tempData['productInfoArea'+i].length !== 0){
                                this.productInfo = tempData['productInfoArea'+i][0];
                            }
                        }
                        this.imgList = this.productInfo.posterSrc.split('分割');
                        this.playerOptions = {
                            playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                            autoplay: false, //如果true,浏览器准备好时开始回放。
                            controls: true, //控制条
                            preload: 'auto', //视频预加载
                            muted: false, //默认情况下将会消除任何音频。
                            loop: false, //导致视频一结束就重新开始。
                            language: 'zh-CN',
                            aspectRatio: '9:16', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                            fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                            sources: [{
                                type: 'video/mp4',
                                src: this.productInfo.playerSrc,
                            }],
                            poster: this.imgList[0]//你的封面地址
                        }
                    }
                )
            },
            getSoftware(packageName){
                this.$http.post('/zm/WMWebsite/queryProductInfos', {}).then(res=>{
                    let count = 0;
                    let tempData = res.data.content;
                    for (let i = 1; i <=3; i++){
                        if (tempData['productInfoArea'+i].length !== 0){
                            let tempList = [];
                            tempList = tempData['productInfoArea'+i];
                            for (let j = 0; j < tempList.length; j++){
                                if (tempList[j].active === 1 && tempList[j].packageName !== packageName){
                                    if (count < 4){
                                        this.software.push(tempList[j]);
                                        count++;
                                    } else {
                                        break;
                                    }
                                }
                            }
                        }
                    }
                })
            },
            androidDown(url, id, count){
                if (url){
                    window.open(url);
                    count = count + 1;
                    this.$http.post('/zm/WMWebsite/updateProductInfo', {'id': id, 'downloadCount': count});
                } else {
                    this.$Message.error('抱歉，该产品的下载链接出现了问题');
                }
            },//安卓下载
        },

        activated() {
            if (this.$route.query.packageName){
                let packageName = this.$route.query.packageName;
                this.productInfo = {};
                this.software = [];
                this.getInfo(packageName);
                this.getSoftware(packageName);
            }
        }
    }
</script>

<style scoped>
  .productInfoArea{
    width: 100%;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
  }
  .totalProduct{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    flex-direction: row;
  }
  .video{
    display: flex;
    width: 40%;
    height: 640px;
    align-items: center;
    justify-content: center;
  }
  .vjs-custom-skin{
    width: 322px;
    height: 572px;
  }
  .textInfo{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 60%;
    height: 640px;
    background: rgba(63, 175, 174, 0.4);
    background: -moz-linear-gradient(right,  rgba(63, 175, 174, 0.4) 0%, white 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(63, 175, 174, 0.4)), color-stop(100%,white));
    background: -webkit-linear-gradient(right,  rgba(63, 175, 174, 0.4) 0%,white 100%);
    background: -o-linear-gradient(right,  rgba(63, 175, 174, 0.4) 0%, white 100%);
    background: -ms-linear-gradient(right,  rgba(63, 175, 174, 0.4) 0%, white 100%);
    background: linear-gradient(to left,  rgba(63, 175, 174, 0.4) 0%,white 100%);
  }
  .productTitle{
    width: 100%;
    font-weight: bold;
    font-size: 3.0rem;
    color: rgba(63, 175, 174, 1);
  }/*产品的名称*/
  .shortInfo{
    width: 100%;
    font-size: 0.9rem;
    color: rgba(63, 175, 174, 1);
    display: flex;
    justify-content: center;
  }
  .contentInfo{
    overflow: hidden;
    display: inline-block;
    text-align: left;
    width: 60%;
    color: rgba(63, 175, 174, 1);
    text-indent: 48px;
    font-size: 24px;
    margin-top: 24px;
  }
  .software{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  .productInfoList{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 200px;
  }
  .listImg{
    display: inline-block;
    width: 100px;
    height: 100px;
  }
  .listInfo{
    text-align: center;
    font-size: 18px;
    font-weight: bold;
  }
  .Download {
    margin-top: 3%;
    display: inline-block;
    text-align: center;
  }/*下载按钮*/
  .listImg:hover{
    cursor: pointer;
  }/*移动到产品上时，鼠标形状*/

  .footer{
    background-color: rgba(57, 207, 204, 1);
    text-align: center;
    width: 100%;
    height: 130px;
  }/*页脚*/
  .footer .info{
    color:#fff;
    font-size:0.8rem;
  }/*页脚：里面的内容*/


  /*手机竖屏*/
  @media only screen
  and (min-width: 320px)
  and (max-width: 767px)
  and (orientation: portrait){
    .totalProduct{
      flex-wrap: wrap;
    }
    .textInfo{
      width: 100%;
      order: 1;
    }
    .video{
      width: 100%;
      order: 2;
    }
  }

  /*手机横屏*/
  @media only screen
  and (min-width: 320px)
  and (max-width: 767px)
  and (orientation: landscape){
    .mainImg img{
      height: 300px;
    }
  }

  /*平板竖屏*/
  @media only screen
  and (min-width: 768px)
  and (max-width: 1024px)
  and (orientation: portrait){
    .mainImg img{
      height: 400px;
    }
  }

  /*平板横屏*/
  @media only screen
  and (min-width: 768px)
  and (max-width: 1024px)
  and (orientation: landscape){
    .mainImg img{
      height: 400px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/productDetails.vue